var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_c('Loading',{attrs:{"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }